// Table tree is used to manage the state of all of the rTables / lists

import { combineReducers } from 'redux';

import ACTIONS from './actions';

const calendarSummarySessionTree = (state = {}, action) => {
    let newState = {};
    switch (action.type) {
        case ACTIONS.CALENDAR_LOAD_ATHLETE_SUMMARY_LAST_COMMENT:
            newState = {
                ...state
            };
            return newState;
        case ACTIONS.CALENDAR_LOAD_ATHLETE_SUMMARY:
            return { ...action.payload.entities.summarySessions };
        case ACTIONS.SUMMARY_ADD_ATHLETE_SUMMARY:
            return { ...state, ...action.payload.entities.summarySessions };
        case ACTIONS.FEED_ITEM_LIKE:
            newState = {
                ...state
            };
            return newState;
        case ACTIONS.COMMENT_ADD_DELETE:
            newState = {
                ...state
            };
            return newState;
        default:
            return state;
    }
};

const calendarSummaryBlockTree = (state = {}, action) => {
    switch (action.type) {
        case ACTIONS.CALENDAR_LOAD_ATHLETE_SUMMARY:
            return { ...action.payload.entities.sets };
        case ACTIONS.SUMMARY_ADD_ATHLETE_SUMMARY:
            return { ...state, ...action.payload.entities.sets };
        default:
            return state;
    }
};

const calendarSummaryExerciseTree = (state = {}, action) => {
    switch (action.type) {
        case ACTIONS.CALENDAR_LOAD_ATHLETE_SUMMARY:
            return { ...action.payload.entities.setExercises };
        case ACTIONS.SUMMARY_ADD_ATHLETE_SUMMARY:
            return { ...state, ...action.payload.entities.setExercises };
        default:
            return state;
    }
};

const calendarSummaryAddedSets = (state = {}, action) => {
    switch (action.type) {
        case ACTIONS.CALENDAR_LOAD_ATHLETE_SUMMARY:
            return { ...action.payload.entities.addedSets };
        case ACTIONS.SUMMARY_ADD_ATHLETE_SUMMARY:
            return { ...state, ...action.payload.entities.addedSets };
        default:
            return state;
    }
};

const calendarSummaryAddedExercises = (state = {}, action) => {
    switch (action.type) {
        case ACTIONS.CALENDAR_LOAD_ATHLETE_SUMMARY:
            return { ...action.payload.entities.addedSetExercises };
        case ACTIONS.SUMMARY_ADD_ATHLETE_SUMMARY:
            return { ...state, ...action.payload.entities.addedSetExercises };
        default:
            return state;
    }
};

const summaryTree = (state = {}, action) => {
    let newState = {};
    switch (action.type) {
        case ACTIONS.CALENDAR_LOAD_TEAM_SUMMARY:
            for (let i = 0; i < action.payload.length; i++) {
                const summary = action.payload[i];
                newState[summary.workout_id] = summary;
            }
            return newState;
        default:
            return state;
    }
};

export default combineReducers({
    summaryTree,
    calendarSummarySessionTree,
    calendarSummaryBlockTree,
    calendarSummaryExerciseTree,
    calendarSummaryAddedSets,
    calendarSummaryAddedExercises
});
